var __templateData = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;



















;return buf.join("");
};
if (typeof define === 'function' && define.amd) {
  define([], function() {
    return __templateData;
  });
} else if (typeof module === 'object' && module && module.exports) {
  module.exports = __templateData;
} else {
  __templateData;
}